import { useMemo } from "react"

import type { Site } from "~/lib/sites"

/**
 * Given an href, return it localized to the given site.
 */
export function useSiteHref({ site, href }: { site: Site; href: string }) {
  return useMemo(() => {
    // Do not attempt to change external hrefs.
    if (href.startsWith("http")) return href

    // Replace a two character prefix like /au/ with a single slash.
    const globalHref = href.replace(/^\/[a-z]{2}\//, "/")

    // Return globalHref with site prefix.
    return (site.urlPrefix ? "/" + site.urlPrefix : "") + globalHref
  }, [href, site])
}
